export interface ApiToken {
  tokenId: number;
  tokenHash: string;
  isActive: boolean;
  expirationDate: string | null;
  created: string;
  createdByName: string | null;
  updatedByName: string | null;
  relations: ApiTokenRelation[];
  endpoints: ApiTokenEndpoint[];
}

export interface ApiTokenRelation {
  relationId: number;
  tokenId: number;
  distributorId: number | null;
  operatorId: number | null;
  actorId: number | null;
  isActive: boolean;
}

export interface ApiTokenEndpoint {
  endpointId: number;
  tokenId: number;
  endpointURL: string;
  httpMethod: string | null;
}

export interface CreateTokenRequest {
  expirationDate?: string | null;
}

export interface UpdateTokenRequest {
  tokenId: number;
  isActive: boolean;
  expirationDate?: string | null;
}

export interface AddRelationRequest {
  distributorId?: number | null;
  operatorId?: number | null;
  actorId?: number | null;
}

export interface AddEndpointRequest {
  endpointURL: string;
  httpMethod?: string | null;
}

export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'] as const;
